import React, { useContext } from 'react';
import { Button, Grid } from 'semantic-ui-react';
import CalculatorStore from '../../app/stores/calculatorStore';
import useWindowDimensions from '../../shared/hooks/dimensionsHook';

const Buttons: React.FC<{ clearForm: Function }> = ({ clearForm }) => {
  const { width } = useWindowDimensions();

  const calculatorStore = useContext(CalculatorStore);
  const { mainLink } = calculatorStore;

  const openLink = () => {
    window.open(mainLink);
  };

  let buttons = (
    <Button.Group>
      <Button onClick={() => clearForm()}>Calcular Novamente</Button>
      <Button.Or text="ou" />
      <Button positive onClick={() => openLink()}>
        Iniciar meu Pedido
      </Button>
    </Button.Group>
  );

  if (width < 480) {
    buttons = (
      <Button.Group size="tiny">
        <Button onClick={() => clearForm()}>Calcular Novamente</Button>
        <Button.Or text="ou" />
        <Button positive onClick={() => openLink()}>
          Iniciar meu Pedido
        </Button>
      </Button.Group>
    );
  }

  return (
    <Grid>
      <Grid.Column textAlign="center">{buttons}</Grid.Column>
    </Grid>
  );
};

export default Buttons;
